import React from 'react';
import { Alert, Label } from 'reactstrap';
import { FieldArray } from 'formik';
import FormikInputField from '~/components/formikInputField/formikInputField';
import FormLayout from '~/components/formLayout/formLayout';
import SubmissionButton from '~/components/submissionButton/submissionButton';
import FormikIngredientOptions from '~/containers/formikIngredientOptions/formikIngredientOptions';
import IconTooltip from '~/components/iconTooltip/iconTooltip';
import AddButton from '~/components/addButton/addButton';
import { renderError, hasError } from '~/utils/formikValidation';

const LotForm = ({ errors, values, handleSubmit, isSubmitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      {errors.unknown && <Alert color="danger">{errors.unknown}</Alert>}
      <FormLayout title="Lot overview">
        <div className="mb3">
          <Label>Reference</Label>
          <FormikInputField name="reference" invalid={!!errors.reference} />
          {errors.reference && <p className="error">{errors.reference}</p>}
        </div>
        <div className="mb3">
          <Label>Volume</Label>
          <FormikInputField name="volume" invalid={!!errors.volume} />
          {errors.volume && <p className="error">{errors.volume}</p>}
        </div>
        <div className="mb3">
          <Label>Scheduled start date</Label>
          <FormikInputField type="date" name="startDate" invalid={!!errors.startDate} />
          {errors.startDate && <p className="error">{errors.startDate}</p>}
        </div>
        <div className="mb3 checkbox-container">
          <Label>
            <FormikInputField type="checkbox" name="isSample" checked={values.isSample} />
            Is this a sample brew only?
          </Label>
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Status">
        <div className="mb3">
          <Label>Status</Label>
          <FormikInputField type="select" name="status">
            <option value="PENDING">Pending</option>
            <option value="ON_HOLD">On hold</option>
            <option value="IN_PROGRESS">In progress</option>
            <option value="CANCELLED">Cancelled</option>
            <option value="COMPLETED">Completed</option>
          </FormikInputField>
        </div>
      </FormLayout>
      {values.status === 'COMPLETED' &&
        !values.isConsolidated && (
          <FormLayout className="mt4" title="Details for completed lot">
            <div className="mb3 checkbox-container">
              <Label>
                <FormikInputField type="checkbox" name="dutyPaid" checked={values.dutyPaid} />
                Duty paid?
              </Label>
            </div>
            <div className="mb3">
              <Label>Permit number</Label>
              <FormikInputField name="permitNumber" />
            </div>
          </FormLayout>
        )}
      {!values.isConsolidated && (
        <FormLayout className="mt4" title="Ingredients">
          <div className="mb3">
            <h5 className="f6 mr3 ttu">Ingredients</h5>
            <FieldArray
              name="ingredients"
              validateOnChange={false}
              render={arrayHelpers => (
                <div>
                  {values.ingredients.map((ingredient, idx) => (
                    <div key={idx}>
                      <div className="flex justify-end">
                        {values.ingredients.length > 1 && (
                          <div className="flex">
                            <IconTooltip
                              icon="delete-circle"
                              text="Remove ingredient"
                              className="ml3 stroke-brand-red"
                              onClick={() => arrayHelpers.remove(idx)}
                            />
                          </div>
                        )}
                      </div>
                      <div className="mh3">
                        <div className="mb3">
                          <Label>Ingredient</Label>
                          <FormikIngredientOptions
                            value={values.productId}
                            type="select"
                            name={`ingredients.${idx}.ingredientId`}
                            invalid={hasError(errors, idx, 'ingredients', 'ingredientId')}
                          />
                          {renderError(errors, idx, 'ingredients', 'ingredientId')}
                        </div>
                        <div className="flex flex-column flex-row-ns">
                          <div className="mb3 mr0 mr3-ns flex-grow-1">
                            <Label>What quantity?</Label>
                            <FormikInputField
                              step=".01"
                              type="number"
                              name={`ingredients.${idx}.amount`}
                              invalid={hasError(errors, idx, 'ingredients', 'amount')}
                            />
                            {renderError(errors, idx, 'ingredients', 'amount')}
                          </div>
                          <div className="mb3">
                            <Label>&nbsp;</Label>
                            <FormikInputField
                              type="select"
                              name={`ingredients.${idx}.measurementType`}
                              invalid={hasError(errors, idx, 'ingredients', 'measurementType')}
                            >
                              <option value="KG">Kilograms</option>
                              <option value="G">Grams</option>
                              <option value="L">Litres</option>
                              <option value="ML">Millilitres</option>
                            </FormikInputField>
                            {renderError(errors, idx, 'ingredients', 'measurementType')}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="tr">
                    <AddButton
                      color="primary"
                      onClick={() =>
                        arrayHelpers.push({
                          measurementType: 'KG'
                        })
                      }
                    >
                      Add another ingredient
                    </AddButton>
                  </div>
                </div>
              )}
            />
          </div>
        </FormLayout>
      )}
      <FormLayout className="mt4" title="Transfers">
        <div className="mb3">
          <Label>Todo</Label>
        </div>
      </FormLayout>
      <FormLayout className="mt4" title="Notes">
        <div className="mb3">
          <Label>Notes</Label>
          <FormikInputField type="textarea" name="notes" />
        </div>
      </FormLayout>
      <div className="flex justify-end mt4">
        <SubmissionButton color="primary" type="submit" isSubmitting={isSubmitting}>
          Save
        </SubmissionButton>
      </div>
    </form>
  );
};

export default LotForm;



// WEBPACK FOOTER //
// ./src/components/lotForm/lotForm.jsx